import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Settings, Users, Trophy } from 'lucide-react';

interface LeagueCardProps {
  name: string;
  color: 'orange' | 'blue';
  onViewLeaderboard: () => void;
  onSettings: () => void;
  className?: string;
}

const LeagueCard: React.FC<LeagueCardProps> = ({
  name,
  color,
  onViewLeaderboard,
  onSettings,
  className = '',
}) => {
  const { t } = useTranslation();
  const toneClass = color === 'orange' ? 'bg-gold-400' : 'bg-info-200';

  return (
    <div
      className={`${toneClass} rounded-xl p-6 relative overflow-hidden ${className}`}
      data-test-id={`league-card-${name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-2 left-2">
          <Users className="w-8 h-8 text-white" />
        </div>
        <div className="absolute top-2 right-2">
          <Settings
            data-test-id="league-settings-btn"
            className="w-6 h-6 text-white cursor-pointer hover:opacity-80 transition-opacity"
            onClick={onSettings}
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <div className="mb-4">
          <h3 className="text-white font-bold text-xl mb-2 text-center">{name}</h3>
        </div>

        <div className="flex justify-center">
          <Button
            data-test-id="league-leaderboard-btn"
            variant="secondary"
            onClick={onViewLeaderboard}
            className="bg-white/20 hover:bg-white/30 text-white border-none backdrop-blur-sm gap-2"
          >
            <Trophy className="w-4 h-4" />
            {t('leaderboard.viewLeague')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LeagueCard;
